export default {"src":"/_next/static/media/check-transparent.006484ee.svg","height":21,"width":20};